export default "__VITE_ASSET__4f669b2b__"